import { styled } from '@mui/material/styles';
import { Tooltip } from 'components/Tooltip';
import { theme } from 'lib/theme';

const HelpLink = styled('div')({
    color: `${theme.palette.secondary.main}`,
    cursor: 'default',
    fontWeight: 400,
    '&:hover': {
      fontWeight: 800,
    }
})

export const FindHelp = props => {
  return (
    <Tooltip
      title="Please reach out to your Client Success Team for further instructions."
      aria-label="find help"
      placement="bottom"
    >
      <HelpLink {...props}>Need Help?</HelpLink>
    </Tooltip>
  );
};
